import api from "./axios";
import {
  OrganogramaItem,
  PapelNoProjeto,
  PessoaDoCliente,
  ProjetoDoCliente,
} from "../interfaces/ClienteEquipe";

/**
 * Equipe de um cliente (projetos com dono, pessoas e organograma). A organização vem na rota e o
 * backend reconfere o escopo (`IEscopoDeCliente`) a cada chamada.
 */
const base = (orgId: number) => `/clientes/${orgId}`;

export const getProjetosDoCliente = async (orgId: number): Promise<ProjetoDoCliente[]> => {
  const { data } = await api.get(`${base(orgId)}/projetos`);
  return Array.isArray(data) ? data : [];
};

/** Pessoas com vínculo ativo no cliente (seletores). Exige `cliente.equipe.gerir`. */
export const getPessoasDoCliente = async (orgId: number): Promise<PessoaDoCliente[]> => {
  const { data } = await api.get(`${base(orgId)}/pessoas`);
  return Array.isArray(data) ? data : [];
};

/** Adiciona a pessoa ao projeto ou troca o papel dela. */
export const definirPessoaNoProjeto = async (
  orgId: number,
  clientProjectId: number,
  pessoaId: number,
  papel: PapelNoProjeto
): Promise<void> => {
  await api.put(`${base(orgId)}/projetos/${clientProjectId}/pessoas/${pessoaId}`, { papel });
};

export const removerPessoaDoProjeto = async (
  orgId: number,
  clientProjectId: number,
  pessoaId: number
): Promise<void> => {
  await api.delete(`${base(orgId)}/projetos/${clientProjectId}/pessoas/${pessoaId}`);
};

export const getOrganograma = async (orgId: number): Promise<OrganogramaItem[]> => {
  const { data } = await api.get(`${base(orgId)}/organograma`);
  return Array.isArray(data) ? data : [];
};

/** `null` deixa a pessoa sem gestor. */
export const definirGestor = async (orgId: number, vinculoId: number, gestorVinculoId: number | null): Promise<void> => {
  await api.put(`${base(orgId)}/organograma/${vinculoId}`, { gestorVinculoId });
};
